import Vue from 'vue'
import VueRouter from 'vue-router'

import login from '../views/login/login.vue'
import userAgreement from '../views/login/userAgreement.vue'
import privacyPolicy from '../views/login/privacyPolicy.vue'
import MainTab from '../views/layout/MainTab.vue'
import RouteStack from '../views/layout/RouteStack.vue'
import homeView from '../views/home/homeView.vue'
import customerUsageGuide from '../views/home/customerUsageGuide.vue'
import meetingRoomList from '../views/home/meetingRoomList.vue'
import selectMeetingRoomTimeSlot from '../views/home/selectMeetingRoomTimeSlot.vue'
import confirmBooking from '../views/home/confirmBooking.vue'
import submittedReviews from '../views/home/submittedReviews.vue'
import myBooking from '../views/myBooking/index.vue'
import bookingSetting from '../views/myBooking/setting.vue'
import bookingDetails from '../views/myBooking/bookingDetails.vue'
import myReviews from '../views/myReviews/index.vue'
import reviewGuide from '../views/myReviews/reviewGuide.vue'
import meetingRoomManage from '../views/meetingRoomManage/index.vue'
import addMeetingRoom from '../views/meetingRoomManage/addMeetingRoom.vue'
import snCodeDoc from '../views/meetingRoomManage/snCodeDoc.vue'
import { getStoredUserInfo } from '@/tools/utils'

Vue.use(VueRouter)

function getUserInfo() {
  return getStoredUserInfo()
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '登录',
      keepAlive: true,
    },
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: userAgreement,
    meta: {
      title: '用户服务协议',
    },
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy,
    meta: {
      title: '隐私政策',
    },
  },
  {
    path: '/',
    component: MainTab,
    redirect: '/home',
    meta: {
      keepAlive: true,
    },
    children: [
      {
        path: 'home',
        component: RouteStack,
        meta: {
          keepAlive: true,
          stackKey: 'home',
        },
        children: [
          {
            path: '',
            name: 'homeView',
            component: homeView,
            meta: {
              title: '会议室',
              tabRoot: true,
            },
          },
          {
            path: 'meetingRoomList',
            name: 'meetingRoomList',
            component: meetingRoomList,
            meta: {
              title: '全部会议室',
              hideTabBar: true,
            },
          },
          {
            path: 'customerUsageGuide',
            name: 'customerUsageGuide',
            component: customerUsageGuide,
            meta: {
              title: '使用指南',
              hideTabBar: true,
            },
          },
          {
            path: 'selectMeetingRoomTimeSlot',
            name: 'selectMeetingRoomTimeSlot',
            component: selectMeetingRoomTimeSlot,
            meta: {
              title: '选择会议时间段',
              hideTabBar: true,
              requiresAuth: true,
            },
          },
          {
            path: 'confirmBooking',
            name: 'confirmBooking',
            component: confirmBooking,
            meta: {
              title: '确认预约',
              hideTabBar: true,
              requiresAuth: true,
            },
          },
          {
            path: 'submittedReviews',
            name: 'submittedReviews',
            component: submittedReviews,
            meta: {
              title: '预约已提交',
              hideTabBar: true,
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'myBooking',
        component: RouteStack,
        meta: {
          keepAlive: true,
          stackKey: 'myBooking',
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            name: 'myBooking',
            component: myBooking,
            meta: {
              title: '我的预约',
              tabRoot: true,
              requiresAuth: true,
            },
          },
          {
            path: 'setting',
            name: 'bookingSetting',
            component: bookingSetting,
            meta: {
              title: '设置',
              hideTabBar: true,
              requiresAuth: true,
            },
          },
          {
            path: 'bookingDetails',
            name: 'bookingDetails',
            component: bookingDetails,
            meta: {
              title: '预约详情',
              hideTabBar: true,
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'myReviews',
        component: RouteStack,
        meta: {
          keepAlive: true,
          stackKey: 'myReviews',
          requiresAuth: true,
          requiresAdmin: true,
        },
        children: [
          {
            path: '',
            name: 'myReviews',
            component: myReviews,
            meta: {
              title: '我的审核',
              tabRoot: true,
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'reviewGuide',
            name: 'reviewGuide',
            component: reviewGuide,
            meta: {
              title: '审核指南',
              hideTabBar: true,
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
        ],
      },
      {
        path: 'meetingRoomManage',
        component: RouteStack,
        meta: {
          keepAlive: true,
          stackKey: 'meetingRoomManage',
          requiresAuth: true,
          requiresAdmin: true,
        },
        children: [
          {
            path: '',
            name: 'meetingRoomManage',
            component: meetingRoomManage,
            meta: {
              title: '会议室管理',
              tabRoot: true,
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'add',
            name: 'addMeetingRoom',
            component: addMeetingRoom,
            meta: {
              title: '添加会议室',
              hideTabBar: true,
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'snCodeDoc',
            name: 'snCodeDoc',
            component: snCodeDoc,
            meta: {
              title: '获取门禁SN码',
              hideTabBar: true,
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
        ],
      },
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  const userInfo = getUserInfo()
  const isLogin = !!userInfo
  const needAuth = to.matched.some((r) => r.meta.requiresAuth)
  const needAdmin = to.matched.some((r) => r.meta.requiresAdmin)

  if (to.path === '/login') {
    if (isLogin) {
      next('/home')
    } else {
      next()
    }
    return
  }

  if (needAuth && !isLogin) {
    next('/login')
    return
  }

  if (needAdmin && !(userInfo && userInfo.isAdmin)) {
    next('/home')
    return
  }

  next()
})

export default router
